var r=/^(?:0|[1-9]\d*)$/;var t=function(t,e){var n=typeof t;return!!(e=null==e?9007199254740991:e)&&("number"==n||"symbol"!=n&&r.test(t))&&t>-1&&t%1==0&&t<e};export{t as _};
//# sourceMappingURL=_isIndex-9419da6b.js.map
